export const API = process.env.REACT_APP_API_URL || "";

export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const notify = (type, text) => {
  window.dispatchEvent(new CustomEvent("app:notify", { detail: { type, text } }));
};

const notifySessionExpired = () => {
  window.dispatchEvent(new CustomEvent("app:session-expired", {
    detail: { text: "Ihre Session ist abgelaufen. Bitte melden Sie sich erneut an." },
  }));
};

const isTokenError = (response, data) => {
  const text = `${data?.error || ""} ${data?.message || ""}`.toLowerCase();
  return response.status === 401 || (response.status === 400 && text.includes("token"));
};

export const readApiResponse = async (response) => {
  const rawBody = await response.text();
  let data = {};

  if (rawBody) {
    try {
      data = JSON.parse(rawBody);
    } catch {
      // Ein vorgeschalteter Server (z. B. Nginx) kann eine HTML-Fehlerseite
      // zurückgeben. Dafür verwenden wir unten eine verständliche Meldung.
    }
  }

  if (!response.ok) {
    const isDeliveryNoteRequest = response.url.includes("/delivery-note");
    const fallbackMessage = response.status === 413
      ? "Das Bild ist für den Upload zu groß. Erlaubt sind maximal 20 MB."
      : response.status === 404 && isDeliveryNoteRequest
        ? "Die Lieferschein-Funktion ist auf dem Server noch nicht verfügbar. Bitte die Server-Version aktualisieren."
        : response.status >= 500
          ? "Der Server konnte die Aktion nicht ausführen. Bitte erneut versuchen."
          : "Die Aktion konnte nicht ausgeführt werden.";
    const error = new Error(data.error || data.message || fallbackMessage);
    Object.assign(error, data);
    error.status = response.status;
    if (isTokenError(response, data)) {
      error.sessionExpired = true;
      notifySessionExpired();
    }
    throw error;
  }

  return data;
};

export const apiFetch = async (path, options = {}) => {
  const response = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });

  return readApiResponse(response);
};
